import { atarrayaApi } from '../../api-common'
import qs from 'qs';

export const state = {
  commercialSizes: [],
  projections: [],
  sizes: [],
  summary: [],
  fullrequest: [],
  newSummary: [],
};

export const getters = {
  commercialSizes: (state) => state.commercialSizes,
  projections: (state) => state.projections,
  sizes: (state) => state.sizes,
  summary: (state) => state.summary,
  newSummary: (state) => state.newSummary,
};

export const mutations = {
  LOAD_COMERCIAL_SIZES(state, data) {
    state.commercialSizes = data;
  },

  ADD_COMERCIAL_SIZE(state, data) {
    state.commercialSizes.push(data);
  },

  UPDATE_COMERCIAL_SIZE(state, data) {
    const index = state.commercialSizes.findIndex((u) => u.id === data.id);
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.commercialSizes[index], attr)) {
          state.commercialSizes[index][attr] = data[attr];
        }
      }
    }
  },

  DELETE_COMERCIAL_SIZE(state, item) {
    state.commercialSizes.splice(state.commercialSizes.indexOf(item), 1);
  },

  LOAD_PROJECTION(state, data) {
    state.projections = data;
  },

  ADD_PROJECTION(state, data) {
    state.projections.push(data);
  },

  LOAD_SIZES(state, data) {
    state.sizes = data;
  },

  updateHarvestedKg (state, { item, index, value }) {
    console.log(item)
    state.summary[index].detail.harvestedKg = parseFloat(value);
  },

  updateEstimatedValues(state, { index, biomassKg, biomassLb, harvestedLb }) {
    state.summary[index].biomassKg = biomassKg;
    state.summary[index].biomassLb = biomassLb;
    state.summary[index].detail.harvestedLb = harvestedLb;
  },

  setSummary(state, data) {
    state.summary = data;
    state.fullrequest = data.fullrequest || [];
  },

  setSummaryFull(state, data) {
    state.fullrequest = data;
  },

  updateHarvestedKgAccepted(state, { itemIndex, containerIndex, harvestedKg, harvestedLb }) {
    const item = state.summary[itemIndex];
    if (item && item.containers && item.containers[containerIndex]) {
      const container = item.containers[containerIndex];
      container.detail.harvestedKg = harvestedKg;
      container.detail.harvestedLb = harvestedLb;
    }
  },

  updateEstimatedValuesAccepted(state, payload) {
    const { itemIndex, containerIndex, harvestedKg, harvestedLb } = payload;

    const item = state.summary[itemIndex];
    if (!item) return;

    const container = state.fullrequest[containerIndex]
    if (!container || !container.detail) return

    container.detail.harvestedKg = harvestedKg
    container.detail.harvestedLb = harvestedLb
  },

  updateHarvestDetails (state, { index, data }) {
    const item = data
    state.newSummary[index] = item
  },

  setNewSummary(state, data) {
    state.newSummary = data;
  },

  updateItem(state, { index, updatedItem }) {
    state.newSummary, index, updatedItem
  },
}

export const actions = {
  async getCommercialSizes({ commit }) {
    const response = await atarrayaApi.get('/oracle/prices');
    commit('LOAD_COMERCIAL_SIZES', response.data);
    return response.data;
  },

  async addCommercialSizes({ commit }, data) {
    const response = await atarrayaApi.post('/oracle/prices', data);
    commit('ADD_COMERCIAL_SIZE', response.data);
    return response.data;
  },

  async editCommercialSizes({ commit }, data) {
    await atarrayaApi.patch(`/oracle/prices/${data.id}`, data);
    commit('UPDATE_COMERCIAL_SIZE', data);
  },

  async deleteCommercialSizes({ commit }, item) {
    await atarrayaApi.delete(`/oracle/prices/${item.id}`);
    commit('DELETE_COMERCIAL_SIZE', item);
  },

  async getProjection({ commit }, data) {
    const response = await atarrayaApi.get('/oracle/projection', {
      params: {
        farmid: data.farmid,
        cntId: data.cntId,
        popid: data.popid,
        genetic: data.genetic,
        growthWeeks: data.growthWeeks,
        nurseryWeeks: data.nurseryWeeks,
        nursery: data.nursery,
        date: data.date,
        densityTarget: data.densityTarget,
        maximumDensity: data.maximumDensity,
        densityType: data.densityType,
        optimize: data.optimize,
        cost: data.cost,
        estimatedProductionCost: data.estimatedProductionCost,
        generationId: data.generationId,
        containerCapacity: data.containerCapacity,
        endingAt: data.endingAt,
        sizeAvg: data.sizeAvg,
        individualSow: data.individualSow,
        observedMortality: data.observedMortality,
        projectedMortality: data.projectedMortality,
        estimatedSurvivalRate: data.estimatedSurvivalRate,
        growth: data.growth
      }
    });

    let jsonString = response.data;
    jsonString = jsonString.replace(/NaN/g, 'null');
    const parsedData = JSON.parse(jsonString);
    commit('LOAD_PROJECTION', parsedData.data);
    return parsedData.data;
  },

  async addProjection({ commit }, data) {
    const response = await atarrayaApi.post('/oracle/projection', data.fullData, {
      params: {
        farm_id: data.params.farmid,
        container: data.params.cntId,
        population: data.params.popid,
        genetic: data.params.genetic,
        growthWeeks: data.params.growthWeeks,
        nurseryWeeks: data.params.nurseryWeeks,
        nursery: data.params.nursery,
        date: data.params.date,
        densityTarget: data.params.densityTarget,
        maxBiomass: data.params.maximumDensity,
        DensityType: data.params.densityType,
        optimize: data.params.optimize,
        cost: data.params.cost,
        estimatedProductionCost: data.params.estimatedProductionCost,
        generationId: data.params.generationId,
        containerCapacity: data.params.containerCapacity,
        endingAt: data.params.endingAt,
        sizeAvg: data.params.sizeAvg,
        individualSow: data.params.individualSow,
        observedMortality: data.params.observedMortality,
        mortalityFactor: data.params.mortalityFactor,
        estimatedSurvivalRate: data.params.estimatedSurvivalRate,
        growth: data.params.growth
      }
    });
    let jsonString = response.data;
    jsonString = jsonString.replace(/NaN/g, 'null');
    const parsedData = JSON.parse(jsonString);
    commit('ADD_PROJECTION', parsedData.data);
    return parsedData.data;
  },

  async getSizes({ commit }, data) {
    const response = await atarrayaApi.get('/oracle/sizes/', {
      params: {
        farmId: data.farmId,
        cntId: data.cntId,
        startDate: data.startDate,
        endDate: data.endDate
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
    commit('LOAD_SIZES', response.data);
    return response.data;
  },

  async getFullProjection({ commit }, data) {
    const response = await atarrayaApi.post('/oracle/harvest/projections/', data);
    response.data.sown = response.data.sown.filter((item) => item.label !== 'NULL');
    response.data.inventory = response.data.inventory.filter((item) => item.label !== 'NULL');
    commit('LOAD_PROJECTION', response.data);
    return response.data;
  },

  async addHarvestEdition({ commit }, data) {
    const response = await atarrayaApi.post('oracle/harvest/editions/', data.fulldata);
    commit('', response.data);
  },

  setSummary({ commit }, data) {
    commit('setSummary', data);
  },

  setNewSummary({ commit }, data) {
    commit('setNewSummary', data);
  },
};
